import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormulaireCoordonneesMouvementCourrielModel } from '../../models/formulaire/formulaire-coordonnees-mouvement-courriel.model';
import { FormulaireCoordonneesMouvementAdresseModel } from '../../models/formulaire/formulaire-coordonnees-mouvement-adresse.model';
import { FormulaireCoordonneesMouvementTelephoneModel } from '../../models/formulaire/formulaire-coordonnees-mouvement-telephone.model';

@Injectable({ providedIn: 'root' })
export class FormulaireMouvementService {
  formGroupCourriel: FormGroup<FormulaireCoordonneesMouvementCourrielModel> | null = null;
  formGroupAdresse: FormGroup<FormulaireCoordonneesMouvementAdresseModel> | null = null;
  formGroupTelephone: FormGroup<FormulaireCoordonneesMouvementTelephoneModel> | null = null;

  setFormCourriel(form: FormGroup<FormulaireCoordonneesMouvementCourrielModel> | null) {
    this.formGroupCourriel = form;
  }

  getFormCourriel(): FormGroup<FormulaireCoordonneesMouvementCourrielModel> | null {
    return this.formGroupCourriel;
  }

  setFormAdresse(form: FormGroup<FormulaireCoordonneesMouvementAdresseModel> | null) {
    this.formGroupAdresse = form;
  }

  getFormAdresse(): FormGroup<FormulaireCoordonneesMouvementAdresseModel> | null {
    return this.formGroupAdresse;
  }

  setFormTelephone(form: FormGroup<FormulaireCoordonneesMouvementTelephoneModel> | null) {
    this.formGroupTelephone = form;
  }

  getFormTelephone(): FormGroup<FormulaireCoordonneesMouvementTelephoneModel> | null {
    return this.formGroupTelephone;
  }
}
